import React from 'react';
import { Spinner, Text } from '@fluentui/react-components';
import './styles.scss';

interface LoadingWrapperProps {
    isLoading: boolean;
    isEmpty?: boolean;
    emptyMessage?: string;
    emptyIcon?: React.ReactNode;
    children: React.ReactNode;
    className?: string;
}

const LoadingWrapper: React.FC<LoadingWrapperProps> = ({
    isLoading,
    isEmpty = false,
    emptyMessage = 'No items found',
    emptyIcon,
    children,
    className = ''
}) => {
    if (isLoading) {
        return (
            <div className={`loading-wrapper loading-wrapper--loading ${className}`}>
                <Spinner size="medium" />
            </div>
        );
    }

    if (isEmpty) {
        return (
            <div className={`loading-wrapper loading-wrapper--empty ${className}`}>
                {emptyIcon && <div className="loading-wrapper__icon">{emptyIcon}</div>}
                <Text>{emptyMessage}</Text>
            </div>
        );
    }

    return <>{children}</>;
};

export default LoadingWrapper;
